









































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class MapPreview extends Vue {
    @Emit() handleRoute() {}
}
